export const garmentTypesColumns = [
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'peso', label: 'Peso (kg)', type: 'number', sortable: true, required: true },
  { 
    id: 'lavanderia', 
    label: 'Centro de Lavado', 
    type: 'asyncSelect', 
    sortable: true, 
    required: true, 
    fetchOptions: async () => {
      try {
        // Importamos dinámicamente para evitar problemas de importación circular
        const { fetchLaundries } = await import('@/pages/parametrizacion/laundries/Services/laundries.services');
        const response = await fetchLaundries({ limit: 100, offset: 1, query: { estado: 'Activo' } });
        
        if (response && response.data) {
          return response.data.map(laundry => ({
            value: { 
              id: laundry._id,
              nombre: laundry.nombre 
            },
            label: laundry.nombre
          }));
        }
        return [];
      } catch (error) {
        console.error('Error cargando centros de lavado:', error);
        return [];
      }
    }
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
];

export const columnsExcel = [
  { key: 'nombre', header: 'Nombre' },
  { key: 'peso', header: 'Peso (kg)' },
  { key: 'lavanderia.nombre', header: 'Centro de Lavado' },
  { key: 'estado', header: 'Estado' },
  { key: 'createdAt', header: 'Fecha de Creación' },
  { key: 'updatedAt', header: 'Fecha de Actualización' },
];
